import FiltersReducer from './FiltersReducer';
export default FiltersReducer;
